export default __webpack_public_path__ + "assets/images/0538fcc73ff303f905022f686179847d.jpg";